import React from 'react';
import { Button } from 'antd';
import { KakaoMap, Text } from 'components';

import Checked from 'assets/radio_checked.svg';
import UnChecked from 'assets/radio_unchecked.svg';

const ReceiveItem = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { item, selected, onSelect } = props;

  /* ===== State ===== */
  const [isOpened, setIsOpened] = React.useState(false);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <li
      key={`item-${item.forwarding_location_id}`}
      style={{
        border: selected ? '2px solid #111111' : '2px solid transparent',
        background: '#EEEEEE',
        padding: 12,
        borderRadius: 10,
        cursor: 'pointer',
      }}
      onClick={() => onSelect(selected ? null : item)}
    >
      <div
        style={{
          padding: 2,
          display: 'flex',
          gap: 12,
          alignItems: 'stretch',
          position: 'relative',
          top: 0,
          left: 0,
        }}
      >
        <div>
          <img src={selected ? Checked : UnChecked} alt="radio" width={20} />
        </div>
        <div>
          <Text weight={700}>{item?.forwarding_name}</Text>

          <div style={{ marginTop: 4 }}>
            <Text size={14} color={'#666666'}>
              [{item.forwarding_postcode}] {item.forwarding_address}
            </Text>
            <Text size={14} color={'#666666'}>
              {item.forwarding_address_detail}
            </Text>
          </div>
        </div>

        <Button
          size="small"
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
          }}
          onClick={() => setIsOpened(!isOpened)}
        >
          위치보기
        </Button>
      </div>

      {isOpened ? (
        <KakaoMap
          name={item.forwarding_name}
          address={item.forwarding_address}
          width={'100%'}
        />
      ) : null}
    </li>
  );
};

export default ReceiveItem;
